<template>
  <basic-layout-dynamic>
    <div class="container">
      設定値は保存されません。また、新しいタブには引き継がれません。
      <h3>外観</h3>
      <div>
        <gl-switch primary v-model="enableSeasonFeature"
          >シーズン機能を有効にする（ベータ）</gl-switch
        >
      </div>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import { ENABLE_SEASON_FEATURE } from '@/const/mutation-types'

export default {
  computed: {
    enableSeasonFeature: {
      get() {
        return this.$store.state.preferences.enableSeasonFeature
      },
      set(value) {
        this.$store.commit(ENABLE_SEASON_FEATURE, value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin-left: var(--spacing-large);
}
</style>
